import { Link } from "gatsby"
import checkForExternalLink from "./checkForExternalLink"
import {
  createProductTrialPageLink,
  createProductDetailPageLink,
} from "../../components/CTAButtons/CTAButtonsConnector"
import formatVideo from "./formatVideo"
import { VideoComponent } from "terra-one"
export const formatPageLinks = (
  link,
  locale = "en",
  type,
  homepageSlug,
  currentSpaceId,
  products,
  siteIdentifier,
  override,
  setOverride,
  contentfulId
) => {
  if (!link && !type) {
    return null
  }

  let videoContent

  if (link?.video) {
    const videoData = formatVideo(link?.video)

    const video = videoData?.video

    const thumbnail = videoData?.thumbnail?.focalPointImage?.url
      ? videoData?.thumbnail
      : null

    videoContent = {
      transcript: videoData?.transcript,
      transcriptText: videoData?.transcriptText,
      closeTranscript: videoData?.closeTranscript,
      video,
      thumbnail,
      variant: "variant_7",
      videoProgress: link?.videoProgress,
      setVideoProgress: link?.setVideoProgress,
    }
    return {
      text: link?.text,
      setOverride,
      override,
      video: videoContent,
      contentfulId,
      VideoComponent,
    }
  }

  if (link?.url?.__typename === "ContentfulProductTrialPage") {
    return createProductTrialPageLink(locale, link)
  } else if (link?.url?.__typename === "ContentfulProductDetailPage") {
    return createProductDetailPageLink(locale, link)
  }

  let prefix = ``
  let text
  if (type && type === "article") {
    prefix = `articles/`
  } else if (type && type === "event") {
    prefix = `events/`
  } else if (type && type === "prose") {
    prefix = `prose/`
  } else if (type && type === "ContentfulNews") {
    prefix = `news/`
  } else if (
    (type && type === "ContentfulProductPage") ||
    link?.url?.__typename === "ContentfulProductPage" ||
    link?.dynamicPageReference?.__typename === "ContentfulProductPage"
  ) {
    prefix = `products/`
  } else if (type && type === "blog post") {
    prefix = `blog/`
  } else if (type && type === "customer story") {
    prefix = `customer-stories/`
  }

  if (link?.text) {
    text = link.text
  }

  if (!link?.text) {
    text = link?.url?.text
  }

  if (link?.url?.url) {
    link.external = checkForExternalLink(link?.url?.url)
  }

  if (link?.url && !link?.url?.url) {
    link.external = checkForExternalLink(link?.url, link?.url?.type)
  }

  const processLinkUrl = link => {
    if (link?.linkAsset?.file) {
      return `https:${link?.linkAsset?.file?.url}`
    } else if (
      link?.url?.type &&
      link?.url?.type === "ContentfulDownloadLink"
    ) {
      return updateDownloadLink(link?.url?.realLink?.url, currentSpaceId)
    } else if (link?.__typename === "ContentfulProductDetailPage") {
      return `/${locale?.toLowerCase()}/products/${link?.url
        ?.split(" ")
        ?.join("-")
        ?.toLowerCase()}/buy`
    } else if (link?.__typename === "ContentfulProductTrialPage") {
        return `/${locale?.toLowerCase()}/products/${link?.url
        ?.split(" ")
        ?.join("-")
        ?.toLowerCase()}/trial`
    } else if (link?.linkUrl) {
      return link?.linkUrl
    } else if (link?.url) {
      if (link?.url?.url?.startsWith("http")) {
        return link?.url?.url
      } else if (link?.url?.startsWith && link?.url?.startsWith("http")) {
        return link?.url
      } else if (locale && typeof locale === "string") {
        if (homepageSlug != null && link?.url?.url === homepageSlug) {
          return `/${locale?.toLowerCase()}/${prefix}`
        } else {
          if (link?.url?.url) {
            return `/${locale?.toLowerCase()}/${prefix}${link?.url?.url?.toLowerCase()}`
          } else if (link?.url && typeof link?.url === "string") {
            return `/${locale?.toLowerCase()}/${prefix}${link?.url?.toLowerCase()}`
          } else {
            return null
          }
        }
      } else if (link?.url?.url) {
        return `/en/${prefix}${link?.url?.url?.toLowerCase()}`
      } else {
        return `/en/${prefix}${link?.url?.toLowerCase()}`
      }
    } else if (link?.url === null && link?.internalLink) {
      return `/${locale?.toLowerCase()}/${link?.internalLink}`
    } else {
      return null
    }
  }
  const url =
    link?.dynamicPageReference?.url != null
      ? processLinkUrl(link?.dynamicPageReference)
      : processLinkUrl(link)

  if (link?.__typename && link?.__typename === "ContentfulSimpleLink") {
    return {
      text: text || link?.linkText,
      onClickHandler: () => window.open(url, "_blank"),
      Link: checkForExternalLink(url) ? null : Link,
      override:
        link?.override || link?.override === false ? link.override : null,
      setOverride: link?.setOverride ? link.setOverride : null,
      url: url,
      destination: url,
      downloadName: link?.linkAsset?.file?.fileName || null,
      contentfulId: link?.contentfulId,
      label: text,
    }
  } else if (link?.url?.type && link?.url?.type === "ContentfulDownloadLink") {

    return {
      text,
      onClick: () => window.open(url, "_blank"),
      Link,
      override:
        link?.override || link?.override === false ? link.override : null,
      setOverride: link?.setOverride ? link.setOverride : null,
      video: link?.video ? link.video : null,
      contentfulId: link?.contentfulId,
    }
  } else {

    return {
      text,
      url,
      Link,
      override:
        link?.override || link?.override === false ? link.override : null,
      setOverride: link?.setOverride ? link.setOverride : null,
      video: link?.video ? link.video : null,
      iconImage: link?.iconImage,
      contentfulId: link?.contentfulId,
      destination: url, // this feels gross, but sometimes buttons use destination and label (t2's SpecialButton), and I don't want to duplicate this whole function to serve those buttons!
      label: text,
    }
  }
}

export const updateDownloadLink = (link, currentSpaceId = "") => {
  if (link && link?.includes("https://assets.ctfassets.net/")) {
    return link.replace(
      `https://assets.ctfassets.net/${currentSpaceId}/`,
      "/downloads/"
    )
  } else if (link && link?.includes("https://downloads.ctfassets.net")) {
    return link.replace(
      `https://downloads.ctfassets.net/${currentSpaceId}/`,
      "/downloads/"
    )
  } else if (link && link?.includes("https://images.ctfassets.net/")) {
    return link.replace(
      `https://images.ctfassets.net/${currentSpaceId}/`,
      "/downloads/"
    )
  }
}

export default formatPageLinks
